var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRadiobutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#D1FE17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3747 6.56094C15.7553 6.96118 15.7393 7.59414 15.3391 7.9747L9.02872 13.9747C8.83624 14.1577 8.57885 14.2567 8.31333 14.2497C8.04782 14.2427 7.79599 14.1304 7.61341 13.9375L4.77375 10.9375C4.3941 10.5364 4.41147 9.90343 4.81257 9.52378C5.21367 9.14412 5.84659 9.1615 6.22625 9.56259L8.37693 11.8347L13.9609 6.5253C14.3612 6.14474 14.9941 6.1607 15.3747 6.56094Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadiobutton);
export default __webpack_public_path__ + "static/media/icon_radiobutton.7d8a0fe39264bb38119540afbf975ea3.svg";
export { ForwardRef as ReactComponent };